import React from 'react';
import { Game } from 'ui/molecules';
export const MobileSlider = ({ items }) => {
    return (React.createElement("div", { className: "last-updated-slider-mobile" },
        React.createElement("div", { className: "last-updated-slider-mobile__scroll" },
            items.map(game => (React.createElement(Game, { key: game._id.toString(), game: game }))),
            React.createElement("div", null, "gutter"))));
};
